// public/js/modules/userState.js


export const currentUserProfile = {
    value: null
};


export const currentUserSongs = {
    value: []
};



export const currentUserTickets = {
    value: 0
};




export function setCurrentUserProfile(profile) {
    currentUserProfile.value = profile;

    window.dispatchEvent(new CustomEvent('currentUserProfileChanged', {
        detail: { profile }
    }));

    if (profile && profile.tickets !== undefined) {
        const oldTickets = currentUserTickets.value || 0;
        const newTickets = profile.tickets;
        currentUserTickets.value = newTickets;

        if (newTickets !== oldTickets) {
            const diff = newTickets - oldTickets;
            if (diff < 0) {
                window.dispatchEvent(new CustomEvent('tickets-updated', {
                    detail: { tickets: newTickets, spent: Math.abs(diff) }
                }));
            } else {
                window.dispatchEvent(new CustomEvent('tickets-updated', {
                    detail: { tickets: newTickets, gained: diff }
                }));
            }
        }
    }
}


export function setCurrentUserSongs(songs) {
    currentUserSongs.value = songs;
}



export function setCurrentUserTickets(tickets) {
    currentUserTickets.value = tickets;
}


export function refreshTicketCount() {
    if (currentUserProfile.value && currentUserProfile.value.tickets !== undefined) {
        currentUserTickets.value = currentUserProfile.value.tickets;
    }
}
